import { RootState } from '@/store';
import { api } from '../core';
import { getCaseDocuments } from '../case';

export interface DocumentGetUploadResponse {
  uploadPath: string;
  uploadToken: string;
}

type DocumentGetUploadProps = {
  abortController?: AbortController;
  documentId: string;
};

const documentGetUploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentGetUpload: builder.query<DocumentGetUploadResponse, DocumentGetUploadProps>({
      query: ({ abortController = new AbortController(), documentId }: DocumentGetUploadProps) => ({
        url: `document/get-upload`,
        method: 'POST',
        body: {
          document_id: documentId
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;

          if (
            typeof state.case.caseId === 'string' &&
            state.caseDocuments.caseDocumentsPagination.pageIndex >= 0 &&
            state.caseDocuments.caseDocumentsPagination.pageSize > 0
          ) {
            dispatch(
              getCaseDocuments.initiate(
                {
                  caseId: state.case.caseId,
                  pageIndex: state.caseDocuments.caseDocumentsPagination.pageIndex,
                  pageSize: state.caseDocuments.caseDocumentsPagination.pageSize
                },
                {
                  forceRefetch: true
                }
              )
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentGetUpload in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentGetUploadQuery } = documentGetUploadApi;
